import { type ColumnDef } from '@tanstack/react-table';
import { GripHorizontal } from 'lucide-react';
import { ColumnType } from '@/types/column';
import { type GalleryView } from '@/types';
import { cn } from '@/lib/utils';

interface DragHandleColumnOptions<T> {
  id?: string;
  accessorKey?: keyof T;
  size?: number;
  label?: string;
  enableSorting?: boolean;
  enableHiding?: boolean;
  minSize?: number;
  maxSize?: number;
  cellClassName?: string;
  headerClassName?: string;
  dataCy?: string;
  galleryView: GalleryView;
}

export const DragHandleColumn = <T extends Record<string, any>>(opts: DragHandleColumnOptions<T>): ColumnDef<T> => {
  const {
    id = ColumnType.DragHandle,
    accessorKey = ColumnType.DragHandle as keyof T,
    label = '',
    galleryView,
    size = 30,
    cellClassName,
    headerClassName,
    enableSorting = false,
    enableHiding = false,
    minSize = 30,
    maxSize = 30,
    dataCy,
  } = opts;

  return {
    id,
    accessorKey,
    header: () => label,
    meta: {
      cellClassName: cn('p-0!', cellClassName),
      ...(headerClassName && { headerClassName: headerClassName }),
    },
    enableSorting,
    enableHiding,
    size,
    minSize,
    maxSize,
    cell: ({ row }) => (
      <button
        className="mx-auto flex h-10 w-full cursor-move items-center justify-center p-0!"
        data-cy={dataCy ?? `${galleryView ? galleryView : 'list'}-${row.index}-${ColumnType.DragHandle}`}
      >
        <GripHorizontal
          className={cn('icon-5', row.getIsSelected() ? 'stroke-text-gray-alternate' : 'stroke-ui-separator', {})}
        />
      </button>
    ),
  };
};
